export default "__VITE_ASSET__db1547fb__"